import { getImage, ImageDataLike } from "gatsby-plugin-image"
import { convertToBgImage } from "gbimage-bridge"

export const asBg = (d: ImageDataLike) => {
  const pluginImage = getImage(d)
  return convertToBgImage(pluginImage)
}
